import { render, staticRenderFns } from "./visitPlanDetails.vue?vue&type=template&id=e0ba2642&scoped=true&"
import script from "./visitPlanDetails.vue?vue&type=script&lang=js&"
export * from "./visitPlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./visitPlanDetails.vue?vue&type=style&index=0&id=e0ba2642&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ba2642",
  null
  
)

export default component.exports